import { Button } from '@/ui'

const REPLIES = {
  connect: { yes: 'Yes, connect me', no: "No, I'm fine" },
  addToOpenCase: { yes: 'Yes, add it', no: "No, that's all" },
}

interface SupportOfferProps {
  addsToOpenCase: boolean
  disabled?: boolean
  onSend: (message: string) => void
}

export const SupportOffer = ({
  addsToOpenCase,
  disabled = false,
  onSend,
}: SupportOfferProps) => {
  const { yes, no } = addsToOpenCase ? REPLIES.addToOpenCase : REPLIES.connect
  return (
    <div className="my-2 flex items-center gap-2">
      <Button
        variant="primary"
        size="sm"
        disabled={disabled}
        onClick={() => onSend(yes)}
      >
        {yes}
      </Button>
      <Button
        variant="secondary"
        size="sm"
        disabled={disabled}
        onClick={() => onSend(no)}
      >
        {no}
      </Button>
    </div>
  )
}
